import Button from 'components/UI/Button';

const WalletButton = ({
    address,
    onClick,
}) => (
    <Button
        className="btn-outline"
        onClick={onClick}
    >
        {address}
    </Button>
);

export default WalletButton;
